import React, { useState, useContext } from 'react';
import {
  Link,
  useParams, useHistory
} from "react-router-dom";
import jwt_decode from "jwt-decode";
import { useCookies } from 'react-cookie';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import decode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { AuthorizeContext } from "../RootContext";
import { api_url } from "../authorize";

import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';

import bg from '../img/background.jpg';
import logo from '../img/LentoLogo_Reverse.png';
import celogo from '../img/ce.png';
import ver from '../img/Version01.jpg';
import md from '../img/md.jpg';
import udi from '../img/udi.jpg';

const useStyles = makeStyles({
  root: {
    maxWidth: 400,
    position: "absolute",
    left: "50%",
    top: "50%",
    webkitTransform: "translate(-50%, -50%)",
    transform: "translate(-50%, -50%)"
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  media: {
    height: 150,
    marginTop: 10,
    paddingTop: 15,
    width: 400,
    // backgroundColor: '#eeeeee'
    backgroundColor: 'white',
    borderBottom: '1px black'
  },
  cemedia: {
    height: 30,
    width: 75,
    margin: '1em'
  },
  title: {
    fontSize: 14,
  },
  textField: {
    fontSize: 15,
    marginBottom:'.8em',
    margin: 'auto'
  },
  //style for font size
  resize:{
    padding: '3em',
    paddingBottom: '2em',
    fontSize:35
  },
  pos: {
    marginBottom: 12,
  },
});

const Login = ({ profile }) => {
  const classes = useStyles();
  const history = useHistory();
  console.log(bg)
  let {setAuthBody, authBody, authenticated,
    setAuthenticated} = useContext(AuthorizeContext);
  const [redirect, setRedirect] = useState(false)
  const [cookies, setCookie] = useCookies(['name']);
  let { warehouse } = useParams()
  const onChange = (option) => {
    const { name, value } = option.target
    setAuthBody({...authBody,
      [name] : value
    })
  }

  console.log(warehouse)
  const handleSubmit =(e) => {
    e.preventDefault()

    axios({
      method: 'POST',
      url: `https://${api_url}/api/login`,
      data: authBody
    }).then(
      res =>{
        if (res.data.token){
          const token = res.data
          const decoded = jwt_decode(token.token, {header: true})
          // sessionStorage.setItem('authBody', decoded);
          sessionStorage.setItem('token', token.token);
          // setCookie('name', res.headers, { path: '/' });
          // authBody = decoded
          setAuthenticated(true)
          console.log(res.data)
          sessionStorage.setItem('authenticated', "true")
          window.location.reload()
        }
        else if (res.data.message){
          alert(res.data.message)
        }
    }).catch(err => alert(err))
  }

  const reloadPage = (e) => {
    e.preventDefault()
    if(authenticated == true){

      window.location.reload()
    }
  }

  if(authenticated == true) {
    return <Redirect to="/" />
  }

  return(

    <div className="center" style={{width: '100%', height: '100%',
      backgroundImage: `url(${bg})`,
      backgroundRepeat: 'no-repeat',
      backgrounPosition: 'center',
      backgroundSize: 'cover'
    }} >
    {/*
      <div style={{zIndex: '2', position: 'absolute', right: '5em', top: '-100px' }}>
        <img src={logo} style={{width: '500px', height: '500px'}}></img>
      </div>
      */}
      <div>
        <Card className={classes.root} variant="outlined">
          <div style={{textAlign: 'center', margin: '1em'}}>
          <h3 style={{fontFamily: 'Roboto, sansSerif'}}>
          <strong>PTOLEMEDIC SYSTEM</strong></h3>
          </div>
          <div style={{textAlign: 'center', margin: '1em'}}>

          <span className="text-Center" style={{color:"gray", fontSize: ".8em"}}><img src={udi} alt="UDI" />  Basic UDI-DI:++G283PtoleMedicSystemFC</span>
          </div>
          <CardContent>
          <div>
            <form onSubmit={handleSubmit}>
              <Input
                className={classes.textField}
                placeholder="Enter Username"
                name="username"
                type="text"
                size="medium"
                onChange={onChange}
                InputProps={{
                  classes: {
                    input: classes.resize
                  }
                }}
                fullWidth
                required
              />
              <Input
                className={classes.textField}
                placeholder="Enter Password"
                name="password"
                type="password"
                InputProps={{
                  pattern: "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}",
                  title: "At least one number and one uppercase and lowercase letter, and at least 8 characters."
                }}
                onChange={onChange}
                fullWidth
                required
                />
                <a href="/">
                <Button type="submit" className="float-right" style={{marginTop: '2em'}} variant="contained" color="primary" size="large"
                onClick={(e) => {
                  handleSubmit(e)
                }}
                >
                Log In
                </Button>
                </a>
            </form>
            <Typography variant="body">
              <Link to="/new-user">New User </Link>
              <Link to="/reset-password"> Reset Password</Link>
            </Typography>
           </div>
          </CardContent>
          <div style={{padding: "0px", marginTop: '1em', textAlign: 'left'}}>
              <div className="col-md-3">
              <span className="text-left"><img src={md} alt="MD" /></span>
              </div>
              <div className="col-md-9" >
                <span className="text-right" style={{color: "red", fontSize: ".8em" }}>
                  *Cutting guide not available for sale in the U.S.A.
                </span>
              </div>
          </div>
          <div style={{textAlign: 'center', paddingRight: '1em'}}>
          <span className="text-Center" style={{color:"gray", fontSize: ".9em"}}><img src={ver} alt="version" />Ver 1.3.1</span>
          <a href="https://lentomedical.com/non-us-resources/" target="_blank" rel="noopener noreferrer">
          <span style={{paddingLeft:"20px", fontSize:"1em"}}>기재사항 등</span>
          </a>
          </div>
        </Card>
      </div>
    </div>
  )
  }

export default Login;
